<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-content :loading="loading" width="800px">
		<kaveh-list v-if="temp" :entity="entity" :data="temp" />
	</kaveh-content>
</template>
<script>
	import { Country } from '@/modules/hub/data/country/detail'
	import { CountryService } from '@/modules/hub/services'
	export default {
		data()
		{
			return {
				temp: null,
				loading: true
			}
		},
		computed:
		{
			entity()
			{
				return Country
			},

			service()
			{
				return new CountryService()
			},
		},
		async beforeMount()
		{
			await this.init()
		},
		methods:
		{
			async init()
			{
				this.temp = await this.getDataFromService();
				if (this.temp == undefined)
				{
					this.$router.go(-1)
				}
			},

			async getDataFromService()
			{
				var result;
				const temp = await this.getDataFromTemp();

				if (temp)
				{
					try
					{
						this.loading = true;
						const payload = {
							'countryId': temp['countryId']
						};
						const res = await this.service.detail(payload)
						result = res.data

					} catch (e) { console.log(e) }
				}

				this.loading = false;
				return result;
			},

			async getDataFromTemp()
			{
				const store = this.$store;
				const router = this.$route;
				const temp = await store.dispatch('temp/findByQuery', router.query);

				return temp ? temp.value : undefined;
			}
		}
	}
</script>